import ScalarIconMinus_vue_vue_type_script_setup_true_lang_default from "./ScalarIconMinus.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconMinus.vue
var ScalarIconMinus_default = ScalarIconMinus_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconMinus_default as default };

//# sourceMappingURL=ScalarIconMinus.js.map